export default __webpack_public_path__ + "static/media/Snd_CU.8a674548.mp3";